export default "__VITE_ASSET__D5f1va7v__"